import React from "react";
import PropTypes from 'prop-types';
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

/**
 * Manages restricted access to the views
 * @param {Object} props - The input parameters.
 * @param {Element} props.element - The HTML element to be used.
 * @param {Object} props.rest - The rest of the parameters.
 */

let redirect_url;

const PrivateRoute = ({ element: Element, ...rest }) => {

  

  const dont_next = ["/", "/logout/"]; // Routes to exclude from redirection

  const location = useLocation();
  const auth = useAuth();

  // Handle routes that should not be redirected
  if (dont_next.includes(location.pathname)) {
    redirect_url = "/login";
  } else if (location.pathname.includes("bloods/boots")) {
    redirect_url = `/phlebotomylogin/?next=${encodeURIComponent(location.pathname)}`;
  } else {
    redirect_url = `/login/?next=${encodeURIComponent(location.pathname)}`;
  }

  // Set the next URL for redirect
  auth?.setNextURl(redirect_url.split("?next=")[1]?.replace(/%2F/g, '/'));
  auth?.setNextURl(redirect_url.split("?next=")[1]?.replace(/%2F/g, '/'));

  if (localStorage.getItem("mfa_pending") === "true") {
    return <Navigate to="/confirm-otp" replace />;
  }

  // If the user is authenticated, render the requested element, otherwise redirect
  return auth?.isAuthenticated ? (
    <Element {...rest} />
  ) : (
    <Navigate to={redirect_url || "/login"} />
  );
};

PrivateRoute.propTypes = {
  element: PropTypes.elementType.isRequired,
};

export default PrivateRoute;